/* eslint-disable */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Set } from 'immutable';
import { QueryFieldModel, SelectUtils, UiConstants } from '../../../util/core-utils';
import { FormTable, FormTableService } from '../../../lib/form/form-table.service';
import { OrderType, QueryResult, } from '../../../lib/util/services';
import { BreadcrumbParent } from '../../../shared/breadcrumb/breadcrumb/breadcrumb.component';
import { TranslateService } from '@ngx-translate/core';
import { StateName } from '../../../app.state-names';
import { FormTableDisabledItem, FormTableSearchModel } from '../../../util/form-table-utils';
import { InputMask } from '../../../util/input-masks';
import { FormTableSearch, FormTableSearchService } from '../../../lib/form-table-search-service';
import { combineLatest, Observable } from 'rxjs';
import { Arrays } from '../../../lib/util/arrays';
import { Strings } from '../../../lib/util/strings';
import { Models } from '../../../util/model-utils';
import { DisabledEnum, DisabledItem } from '../../../util/search-utils';
import { RightModel } from '../../../app.rights';
import { RightResolver, RightService } from '../../../lib/right.service';
import { DropdownItemType } from '../../../shared/dropdown/dropdown-item/dropdown-item-type';
/* eslint-enable */

@Component({
  selector: 'app-form-table-list',
  templateUrl: 'form-table-list.component.html',
  styleUrls: ['form-table-list.component.scss']
})
export class FormTableListComponent implements OnInit, OnDestroy {

  FormTable = FormTable;
  UiConstants = UiConstants;
  DropdownItemType = DropdownItemType;

  queryModel: QueryFieldModel<FormTable.OrderField> = new QueryFieldModel(FormTable.OrderField.ID, OrderType.DESC);
  formTableList: Array<FormTable.FormTable> = [];
  showSearch: boolean = false;
  breadcrumbParents: BreadcrumbParent[] = [];
  breadcrumbSelf: string;
  compactSidebar: boolean = document.querySelector('body')!.classList.contains('sidebar-compact');

  searchModel: FormTableSearchModel = new FormTableSearchModel();
  formTableDisabledItems: DisabledItem[] = [];
  InputMask = InputMask;
  SelectUtils = SelectUtils;
  rightModel: RightModel = RightModel.empty();

  constructor(
    private formTableService: FormTableService,
    private translateService: TranslateService,
    private rightService: RightService,
    private formTableSearchService: FormTableSearchService) {
  }

  ngOnInit() {
    this.translateService.get('MENU_NAVBAR_FORM_TABLE').subscribe(
      (result: string) => {
        this.breadcrumbSelf = result;
      }
    );
    this.translateService.get('MENU_NAVBAR_MENU_ADMINISTRATION').subscribe(
      (result: string) => {
        this.breadcrumbParents.push({name: result, uiSref: StateName.ADMIN_DASHBOARD});
      }
    );
    this.loadRightModels();
    this.loadSearch(() => {
      this.showSearch = !this.searchModel.isEmpty();
      this.initDisabledOptions(DisabledEnum.FALSE);
      this.loadList();
    });
  }

  private loadRightModels() {
    this.rightService.getRightResolver().subscribe(
      (resolver: RightResolver) => {
        this.rightModel = RightModel.of(resolver);
      }
    );
  }

  private loadSearch(completion: () => void) {
    const obs: Observable<SearchLoadResult> = combineLatest(
      this.formTableSearchService.getSearchData({}),
      (storedSearchData: FormTableSearch.SearchDataResult) => {
        const result: SearchLoadResult = {
          storedSearchData: storedSearchData
        };
        return result;
      }
    );
    obs.subscribe(
      (result: SearchLoadResult) => {
        this.postInitSearch(result.storedSearchData);
        completion();
      }
    );
  }

  private initDisabledOptions(initValue: DisabledEnum) {
    this.formTableDisabledItems = [];
    const disabledEnums: DisabledEnum[] = [DisabledEnum.NONE, DisabledEnum.FALSE, DisabledEnum.TRUE];
    Arrays.iterateByIndex(disabledEnums, (key) => {
      const item = new DisabledItem();
      item.id = key;
      this.translateService.get('COMMON_VALUE_DISABLED_ENUM_' + key).subscribe(
        (text: string) => {
          item.text = text;
        }
      );
      this.formTableDisabledItems.push(item);
      if (!this.searchModel.disabled) {
        if (key === initValue) {
          this.searchModel.disabled = item;
        }
      }
    });
  }

  private postInitSearch(storedSearchData: FormTableSearch.SearchDataResult) {
    this.queryModel.itemsPerPage = storedSearchData.searchData.itemsPerPage;
    this.queryModel.setOrder(storedSearchData.searchData.order);
    this.queryModel.currentPage = storedSearchData.searchData.pageNumber;
    this.searchModel.id = storedSearchData.searchData.id;
    this.searchModel.name = storedSearchData.searchData.name;
    this.searchModel.externalId = storedSearchData.searchData.externalId;
    this.searchModel.disabled = storedSearchData.searchData.disabled;
  }

  private getActiveItem(): FormTableDisabledItem {
    const item = new FormTableDisabledItem();
    item.id = 'ACTIVE';
    item.text = 'FORM_TABLE_SEARCH_FIELD_DISABLED_ACTIVE';
    return item;
  }

  pageChanged(selectedPage: number) {
    this.loadList(selectedPage);
  }

  itemsPerPageChanged(itemsPerPage: number) {
    this.queryModel.itemsPerPage = itemsPerPage;
    this.loadList(1);
  }

  orderBy(field: FormTable.OrderField) {
    this.queryModel.onOrderFieldChanged(field);
    this.loadList(1);
  }

  setDisabled(event: any, formTable: FormTable.FormTable, disabled: boolean) {
    this.formTableService.setDisabled({
      formTableId: formTable.id,
      disabled: disabled
    }).subscribe(
      (result: FormTable.FormTable) => {
        this.loadList();
      },
      (error: any) => {
        this.loadList();
      }
    );
  }

  private loadList(pageNumber?: number) {
    const requestedPage = pageNumber ? pageNumber : this.queryModel.currentPage;
    const order = this.queryModel.getOrder();
    const formTableIdSet: number[] = [];
    const disabled: boolean | undefined = !this.searchModel.disabled ||
    this.searchModel.disabled.id === DisabledEnum.NONE ?
      undefined : this.searchModel.disabled.id === DisabledEnum.TRUE;
    if (Models.parseNumber(this.searchModel.id)) {
      formTableIdSet.push(Models.parseNumber(this.searchModel.id)!);
    }
    this.formTableService.query({
      formTableIdSet: Set.of(...formTableIdSet),
      name: Strings.undefinedOrNonEmpty(this.searchModel.name),
      externalId: Strings.undefinedOrNonEmpty(this.searchModel.externalId),
      disabled: disabled,
      orders: Set.of(order),
      paging: {
        pageNumber: requestedPage,
        numberOfItems: this.queryModel.itemsPerPage
      }
    }).subscribe(
      (result: QueryResult<FormTable.FormTable>) => {
        this.formTableList = result.items.toArray();
        this.queryModel.currentPage = requestedPage;
        this.queryModel.totalNumberOfItems = result.pagingResult.totalNumberOfItems;
        this.queryModel.currentNumberOfItems = result.pagingResult.currentNumberOfItems;
      }
    );
  }

  getDisabled(): boolean | undefined {
    if (this.searchModel.disabled!.id === DisabledEnum.FALSE) {
      return false;
    }
    else if (this.searchModel.disabled!.id ===  DisabledEnum.TRUE) {
      return true;
    }
    return undefined;
  }

  onSearchClicked() {
    this.loadList();
  }

  onSearchReset() {
    this.formTableSearchService.resetSearchData({}).subscribe(
      (result) => {
        this.loadSearch(() => {
          this.showSearch = true;
          this.loadList(1);
        });
      }
    );
  }

  private saveSearch() {
    const request = {
      searchData: {
        itemsPerPage: this.queryModel.itemsPerPage,
        order: this.queryModel.getOrder(),
        pageNumber: this.queryModel.currentPage,
        id: this.searchModel.id,
        name: this.searchModel.name,
        externalId: this.searchModel.externalId,
        disabled: this.searchModel.disabled
      }
    };
    this.formTableSearchService.setSearchData(request).subscribe(
      (result) => {
      },
      (error) => {
      }
    );
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
  }

  ngOnDestroy() {
    this.saveSearch();
  }

}

interface SearchLoadResult {
  storedSearchData: FormTableSearch.SearchDataResult,
}
